import axios from 'axios';
import config from '@/config';

export const serviceStations = {
  namespaced: true,
  state: {
    serviceStations: [],
    selected: {},
    filtered: [],
    closest: null,
  },
  actions: {
    setServiceStations({ commit }, stations) {
      commit('setServiceStations', stations);
    },
    fetchServiceStations({ dispatch }) {
      return new Promise((resolve, reject) => {
        axios.get(`${config.apiUrl}${config.apiEndpoints.serviceStations}`)
          .then((res) => {
            if (res.status === 200) {
              dispatch('setServiceStations', res.data);
              dispatch('filterServiceStations', '');
              resolve(res);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
    setSelectedServiceStation({ commit }, station) {
      commit('setSelectedServiceStation', station);
    },
    filterServiceStations({ commit }, filter) {
      commit('filterServiceStations', filter);
    },
    setClosest({ commit }, station) {
      commit('setClosest', station);
    },
  },
  mutations: {
    setServiceStations(state, stations) {
      state.serviceStations = stations;
    },
    setClosest(state, station) {
      state.closest = station;
    },
    setSelectedServiceStation(state, station) {
      state.selected = station;
    },
    filterServiceStations(state, filter) {
      const normalizeString = string => string ? string.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l') : '';
      if (filter !== '') {
        state.filtered = state.serviceStations.filter((serviceStation) => {
          const {
            city, name, streetNumber,
          } = serviceStation;

          const filterText = normalizeString(filter);
          return normalizeString(city).includes(normalizeString(filterText))
            || normalizeString(name).includes(normalizeString(filterText))
            || normalizeString(streetNumber).includes(normalizeString(filterText));
        });
      } else {
        state.filtered = state.serviceStations;
      }
    },
  },
  getters: {
    getClosest(state) {
      return state.closest;
    },
    getServiceStations(state) {
      return state.serviceStations;
    },
    getSelected(state) {
      return state.selected;
    },
    getFiltered(state) {
      return state.filtered;
    },
  },
};
